@switch (task.status) { @case ('completed') {
<alaris-tag [dot]="true" mode="success">{{ 'simulation.statuses.completed' | translate }}</alaris-tag>
} @case ('inProgress') {
<alaris-tag [dot]="true" mode="info">{{ 'simulation.statuses.in_progress' | translate }}</alaris-tag>
} @case ('failed') {
<alaris-tag [dot]="true" mode="error">{{ 'simulation.statuses.failed' | translate }}</alaris-tag>
} @default {
<alaris-tag [dot]="true" mode="error"></alaris-tag>
} }
